import { useTranslation } from 'next-i18next';
import type { Market } from '@bridebook/toolbox/src/gazetteer';
import { IUISupplier, Slug } from '@bridebook/toolbox/src/types';
import { formatArea } from '@bridebook/web/lib/search/utils';
import { getInsertAPlural } from '@bridebook/web/lib/supplier/utils';

interface IProps {
  actualCategory: Slug | '';
  area: string;
  list: IUISupplier[];
  market: Market;
}

/**
 * Creates a meta description based on area, category slug and list of suppliers (different value
 * for single element in suppliers array and for more than one suppliers on the list).
 */
export const useSearchMetaDesc = ({ actualCategory, area, list, market }: IProps) => {
  const { t } = useTranslation('search');
  const insertA = getInsertAPlural(actualCategory as Slug);
  const formattedArea = formatArea(area, market);
  const arr = list;
  let metaDesc = t('head.first', {
    category: insertA,
    area: formattedArea,
  });
  if (arr.length > 0) {
    metaDesc += ' ';
    if (arr.length === 1) {
      metaDesc += t('head.second.one', {
        supplier1: arr[0].name,
      });
    } else {
      metaDesc += t('head.second.two', {
        supplier1: arr[0].name,
        supplier2: arr[1].name,
      });
    }
  }
  return metaDesc;
};
